
const getListRecord = state => state.list
const getRecordExam = state => state.createRecordExam

export default {
  getListRecord,
  getRecordExam
}



// WEBPACK FOOTER //
// ./src/store/modules/examination-report/getters.js